import { render } from "./edit.vue?vue&type=template&id=8fc9cd78&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import "./edit.vue?vue&type=style&index=0&id=8fc9cd78&scoped=true&lang=css"

import exportComponent from "D:\\SchoolManagement-Vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fc9cd78"]])

export default __exports__